export const editProfileShowBankAccountInfo: boolean = true;
